// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"312008f9","81":"db4a56f0","86":"f92fc66c","237":"822e091c","277":"61ff43a0","499":"494ba1ff","638":"20e9abe1","639":"82206c13","754":"bd8a4d3b","881":"8b1e647c"}[chunkId] + ".chunk.js";
};